<template>
  <div>
    <div v-if="mayAddClientIdentity" class="h-panel">
      <b-button
        :to="{name: 'player_client_identity_add', params: {playerId: playerId}}"
      >
        Add client identity
      </b-button>
    </div>

    <table v-if="clientIdentities !== null && clientIdentities.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Type</th>
          <th scope="col">Id</th>
          <th
            v-if="mayDelClientIdentity"
            scope="col"
            class="action"
          >
            Action
          </th>
        </tr>
      </thead>
      <tr
        v-for="clientIdentity in clientIdentities"
        :key="clientIdentity.Id"
      >
        <td>
          {{clientIdentity.Type | getClientIdentityTypeName}}
        </td>
        <td>
          <span class="custom-code">{{clientIdentity.Id}}</span>
        </td>
        <td v-if="mayDelClientIdentity" class="action">
          <b-button @click='deleteClientIdentityWithConfirmation(clientIdentity)' variant="danger" size="sm">Delete</b-button>
        </td>
      </tr>
    </table>

    <p v-if="message !== null">
      {{message}}
    </p>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';
import { confirmAction } from '../service/confirm';

import LoadingIndicator from './LoadingIndicator.vue';

import { getClientIdentityTypeName } from '../model/player';
import { mayAddClientIdentity as doMayAddClientIdentity } from '../model/player';
import { mayDelClientIdentity as doMayDelClientIdentity } from '../model/player';

import { arrayDeleteFirstItemByValue } from '../util';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'PlayerClientIdentities',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      actor: auth.getViewer(),

      loadState: LOAD_STATE_INIT,
      clientIdentities: null,
    };
  },

  computed: {  
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    message() {
      if(this.isLoadedNormal && this.clientIdentities !== null && this.clientIdentities.length === 0) {
        return 'No client identities.';
      }
      return null;
    },

    mayAddClientIdentity() {
      return doMayAddClientIdentity(this.actor.role);
    },

    mayDelClientIdentity() {
      return doMayDelClientIdentity(this.actor.role);
    },
  },

  created() {
    this.loadIdentities();
  },

  methods: {
    loadIdentities() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const url = `/player/${this.playerId}/client_identities`;
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.clientIdentities = data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    deleteClientIdentityWithConfirmation(clientIdentity) {
      this.confirmClientIdentityDeletion(() => {
        this.deleteClientIdentity(clientIdentity);
      });
    },

    // function onConfirmed()
    confirmClientIdentityDeletion(onConfirmed) {
      confirmAction(
        this,
        'Are you sure you want to delete this client identity {env}?',
        'Delete',
        onConfirmed,
      );
    },

    deleteClientIdentity(clientIdentity) {
      notifier.deleteSenderNotifications(this);
      
      const url = `/player/${this.playerId}/client_identity/del`;

      const formData = new FormData();
      formData.set('type', clientIdentity.Type);
      formData.set('id',   clientIdentity.Id);

      HTTP.post(url, formData)
      .then(() => {
        arrayDeleteFirstItemByValue(this.clientIdentities, clientIdentity);
        notifier.showSuccess('Client identity deleted.');
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },

  filters: {
    getClientIdentityTypeName,
  },
};
</script>

<style scoped>
.action {
  width: 1px;
}
</style>
